// extracted by mini-css-extract-plugin
export default {"tasks":"cP-z","task":"dP-z","svg":"eP-z","text":"fP-z"};